import { Navigate } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";

const ProtectedRoute = ({ permissionKey, children }) => {
  const { hasPermission } = usePermissions();
  // const hasAccess = primaryNavigationChecker(permissionKey, role);
  const hasAccess = hasPermission(permissionKey);

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
